import React from "react";

const LOGO_URL = "/atc-logo.png";

/**
 * Mini live preview of the public header — mirrors whatever's currently
 * in the NavigationManager's items array + quote-button toggle.
 */
const NavPreview = ({ items, showQuoteButton }) => {
  const visible = items.filter((it) => it.visible);
  return (
    <div className="rounded-2xl border border-white/10 overflow-hidden bg-slate-950" data-testid="nav-preview">
      <div className="px-4 py-2 border-b border-white/10 bg-slate-900/50 flex items-center justify-between">
        <div className="text-[10px] uppercase tracking-[0.2em] text-slate-400">Live preview · desktop header</div>
        <div className="flex items-center gap-1">
          <span className="h-2 w-2 rounded-full bg-rose-500/60" />
          <span className="h-2 w-2 rounded-full bg-amber-500/60" />
          <span className="h-2 w-2 rounded-full bg-emerald-500/60" />
        </div>
      </div>
      <div className="relative px-5 py-3 bg-slate-950/80 backdrop-blur-xl border-b border-white/5 flex items-center gap-4">
        <div className="flex items-center gap-2 shrink-0">
          <img src={LOGO_URL} alt="" className="h-8 w-8 object-contain" />
          <div className="leading-tight">
            <div className="font-display font-black text-xs text-white tracking-tight">ATC</div>
            <div className="text-[8px] uppercase tracking-[0.18em] text-slate-400">Mold & Water</div>
          </div>
        </div>

        <nav className="flex flex-1 min-w-0 flex-wrap items-center justify-around gap-x-3 gap-y-1.5 min-h-[24px] px-2">
          {visible.length === 0 ? (
            <span className="text-[10px] uppercase tracking-wider text-slate-600">empty — all tabs hidden</span>
          ) : (
            visible.map((it) => (
              <span
                key={it.id}
                className="text-xs text-slate-300 whitespace-nowrap"
                data-testid={`preview-${it.id}`}
              >
                {it.label}
              </span>
            ))
          )}
        </nav>

        {showQuoteButton ? (
          <span className="shrink-0 px-3 py-1.5 rounded-full text-[10px] font-medium text-white brand-gradient whitespace-nowrap" data-testid="preview-quote-button">
            Request Quote
          </span>
        ) : (
          <span className="shrink-0 text-[10px] text-slate-600 italic">no quote button</span>
        )}
      </div>
    </div>
  );
};

export default NavPreview;
